// extracted by mini-css-extract-plugin
export default {"budge-text-box":"budge-text-box___L042E","budge-text":"budge-text___ckRfy","amount":"amount____8Udu"};